






























































/* eslint-disable camelcase */

import { mapState } from "vuex";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import InputTextarea from "@/common/components/atoms/InputTextarea.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";

import { extend, ValidationProvider, ValidationObserver } from "vee-validate";

import { required } from "vee-validate/dist/rules";
import { Component, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

extend("required", {
  ...required,
  message: "{_field_}を入力してください。"
});

@Component({
  components: {
    ButtonMain,
    InputTextarea,
    SmallText,
    ValidationProvider,
    ValidationObserver
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheJ05ChatForms extends Vue {
  colorCode!: string;
  isSp = globals.isSpScreenWidth;
  message = "";
  hoverFileIconState = false;
  fileIconColor = {
    true: this.colorCode,
    false: "#333333"
  };

  get currentFileIconColor() {
    if (this.hoverFileIconState) {
      return this.colorCode;
    } else {
      return "#333333";
    }
  }

  mounted() {
    this.initCustomColorCode();
  }

  initCustomColorCode() {
    this.fileIconColor.true = this.colorCode;
  }

  doSend(e: any, ObserverProps: any) {
    const { message } = this;
    const dateObject = new Date();
    const date = "";
    const unread = false;

    const messageObj = {
      date,
      unread,
      message
    };

    ObserverProps.passes(() => {
      this.$emit("do-send", messageObj);
      this.resetFormData();
    });
  }

  resetFormData() {
    this.message = "";
  }
}
